import { Link as RouterLink, Navigate } from 'react-router-dom';
import { Box, Button, Container, Stack, Typography } from '@mui/material';

import useAuth from '../auth/useAuth';
import { PATH_AFTER_LOGIN, ROLES } from '../config';

export default function NotFoundPage() {
  const { role } = useAuth();

  // El distribuidor no sale de su lista de precios (ver ClientLayout).
  if (role === ROLES.DISTRIBUIDOR) {
    return <Navigate to={PATH_AFTER_LOGIN[ROLES.DISTRIBUIDOR]} replace />;
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
        <Stack spacing={2} sx={{ alignItems: 'center', textAlign: 'center', width: '100%' }}>
          <Typography variant="h1" color="primary.main">
            404
          </Typography>
          <Typography variant="h5">Página no encontrada</Typography>
          <Typography variant="body2" color="text.secondary">
            La página que buscas no existe o fue movida.
          </Typography>
          <Button component={RouterLink} to="/" variant="contained">
            Volver al inicio
          </Button>
        </Stack>
      </Box>
    </Container>
  );
}
